import { useEffect, useState } from "react";
import { api, asArray } from "@/lib/api";
import { Wand2, Unlock, RotateCcw } from "lucide-react";

const TASK_ICON = { unlock_accounts: Unlock, restart_explorer: RotateCcw, restart_outlook: RotateCcw, restart_teams: RotateCcw };

export default function Remediation() {
  const [items, setItems] = useState([]);
  const [tasks, setTasks] = useState([]);
  useEffect(() => {
    api.get("/remediation/rules").then(r => setItems(asArray(r.data))).catch(() => setItems([]));
    api.get("/remediation/tasks").then(r => setTasks(asArray(r.data))).catch(() => setTasks([]));
  }, []);
  return (
    <div className="space-y-4">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Auto Remediation</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Rules ({items.length})</h1>
      </div>

      {/* One-click maintenance tasks — run per device from its page */}
      {tasks.length > 0 && (
        <div>
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mb-2">Maintenance tasks · run from a device page</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {tasks.map(t => {
              const Icon = TASK_ICON[t.id] || Wand2;
              return (
                <div key={t.id} className="bg-zinc-950 border border-zinc-900 rounded-md p-4">
                  <Icon size={16} className="text-blue-400 mb-2" />
                  <div className="text-sm text-zinc-100">{t.name}</div>
                  <div className="text-[11px] text-zinc-500 mt-0.5">{t.desc}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {items.map(r => (
          <div key={r.id} className="bg-zinc-950 border border-zinc-900 rounded-md p-5">
            <div className="flex items-center gap-2"><Wand2 size={14} className="text-blue-400"/><div className="font-display font-medium">{r.name}</div><span className="ml-auto text-[10px] uppercase tracking-widest font-mono text-emerald-400">{r.enabled?"enabled":"disabled"}</span></div>
            <div className="mt-2 text-[10px] uppercase tracking-widest text-zinc-500 font-mono">Trigger</div>
            <code className="text-xs bg-zinc-900/40 border border-zinc-900 rounded px-2 py-1 inline-block mt-1">{r.trigger}</code>
            <div className="mt-2 text-[10px] uppercase tracking-widest text-zinc-500 font-mono">Action</div>
            <code className="text-xs bg-zinc-900/40 border border-zinc-900 rounded px-2 py-1 inline-block mt-1">{r.action}</code>
          </div>
        ))}
      </div>
    </div>
  );
}
